import { Typography } from '../../../src/types/types.js'
import { font } from './font.js'

export const typography: Typography = {
  id: 'raleway',
  name: 'Raleway',

  font,
}
